import React from 'react';
import {
  Card,
  Col,
  Divider,
  Empty,
  Icon,
  message,
  Pagination,
  Popconfirm,
  Row,
} from 'antd';
import {Link} from 'react-router-dom';
import {patch, post} from '../../../components/mc_axios/McAxios';

class MedpixxTrash extends React.Component {
  state = {
    medpixxList: [],
    currentPageNumber: 1,
    itemsPerPage: 10,
    totalItems: 0,
    paginationStart: 1,
  };

  componentDidMount() {
    this.getMedpixxList();
  }

  getMedpixxList = () => {
    const {itemsPerPage, currentPageNumber} = this.state;

    let data = {
      count: itemsPerPage,
      page_number: currentPageNumber,
      subject: '',
      status: 3,
      search_term: '',
    };

    post('/api/medpixx/images', data).then(response => {
      if (response.data.status === true) {
        let resData = response.data.data;
        this.setState({
          totalItems: resData.count,
          medpixxList: resData.list,
        });
      }
    });
  };

  confirm(actionType, medpixxId) {
    if (actionType === 1) {
      patch('/api/medpixx/images/restore', {medpixx_id: medpixxId}).then(
          response => {
            if (response.data.status === true) {
              message.success('Medpixx has been restored successfully');
              this.getMedpixxList();
            } else {
              message.error('Something went wrong. Try again.');
            }
          },
      );
    } else {
      post('/api/medpixx/images/delete', {medpixx_id: medpixxId}).then(
          response => {
            if (response.data.status === true) {
              message.success('Medpixx has been deleted successfully');
              this.getMedpixxList();
            } else {
              message.error('Something went wrong. Try again.');
            }
          },
      );
    }
  }

  onPageChange = pageNumber => {
    let actualPage = Math.max(0, pageNumber - 1);
    let start = actualPage * this.state.itemsPerPage;
    this.setState(
        {
          currentPageNumber: pageNumber,
          paginationStart: start + 1,
        },
        () => {
          this.getMedpixxList();
        },
    );
  };

  render() {
    const {
      medpixxList,
      currentPageNumber,
      itemsPerPage,
      totalItems,
    } = this.state;

    return (
        <div className="main-content-block">
          <Row gutter={16}>
            <Col span={24}>
              <div className="page-header">
                <Link to={'/dashboard/medpixx/'}>
                  <Icon type="arrow-left" title={'Back'}/>
                </Link>
                <Divider type="vertical"/> Trash
              </div>
            </Col>
            <Col span={24}>
              <hr className="mc-mt-10"/>
            </Col>
          </Row>
          {medpixxList !== undefined && medpixxList.length > 0 ? (
              <Row gutter={16} className="mc-mt-10 medpixx-grid">
                {medpixxList.map((data, index) => (
                    <Col span={6} key={index}>
                      <Card
                          actions={[
                            <Popconfirm
                                title="Are you sure restore this medpixx?"
                                onConfirm={() => this.confirm(1,
                                    data.medpixx_id)}
                                onCancel={() =>
                                    message.error(
                                        'You have canceled the restore operation')
                                }
                                okText="Yes"
                                cancelText="No"
                            >
                              <Icon type="undo" title="Restore"/>
                            </Popconfirm>,
                            <Popconfirm
                                title="Are you sure delete this medpixx?"
                                onConfirm={() => this.confirm(2,
                                    data.medpixx_id)}
                                onCancel={() =>
                                    message.error(
                                        'You have canceled the delete operation')
                                }
                                okText="Yes"
                                cancelText="No"
                            >
                              <Icon type="delete" title="Delete"/>
                            </Popconfirm>,
                          ]}
                      >
                        <img
                            src={data.medpixx_image_url}
                            alt="Medpixx"
                            style={{width: '100%', height: 'auto'}}
                        />
                      </Card>
                    </Col>
                ))}
                <Col span={24}>
                  <br/>
                  <Pagination
                      current={currentPageNumber}
                      pageSize={itemsPerPage}
                      total={totalItems}
                      onChange={this.onPageChange}
                  />
                </Col>
              </Row>
          ) : (
              <Empty
                  className="mc-mtb-100"
                  image="https://s3.ap-south-1.amazonaws.com/copy-medcampus/wp-content/uploads/2019/03/06191929/no-data.png"
                  description={<span>No deleted medpixxs found</span>}
              />
          )}
        </div>
    );
  }
}

export {MedpixxTrash};
